import { useRef } from 'react';
import SearchIcon from '../../assets/icons/InputIcon.svg';
import CancelIcon from '../../assets/icons/new_icon/tag-cross.svg';
import './SearchInput.scss';

interface Props {
  value: string;
  onChange: (newValue: string) => void;
}

export default function SearchInput({ value, onChange }: Props) {
  const inputRef = useRef(null);

  const onClickIcon = () => {
    if (value) {
      onChange('');
    }
    if (inputRef.current !== null) {
      const input = inputRef.current as HTMLInputElement;
      input.focus();
    }
  };

  return (
    <div className='SearchInput'>
      <input
        ref={inputRef}
        placeholder='Search here'
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <button
        onClick={onClickIcon}
      >
        <img
          alt=''
          src={value ? CancelIcon : SearchIcon}
        />
      </button>
    </div>
  );
}
